import { Typography } from "@povio/ui";
import { Fragment } from "react";

import ProfileSectionRow from "@/components/home/sections/components/ProfileSectionRow";
import ProfileWorkExperienceItem from "@/components/home/sections/components/ProfileWorkExperienceItem";
import type { ISectionProps } from "@/components/home/sections/ProfileBioSection";
import ProfileSectionCard from "@/components/home/sections/ProfileSectionCard";
import { ItemSectionDivider } from "@/components/ui/ItemSectionDivider";
import type { CommonModels } from "@/data/common/common.models";
import { DateUtils } from "@/util/date.utils";

interface IProps extends ISectionProps {
  recognitions?: CommonModels.AchievementOrAwardDto[];
}

const ProfileRecognitionsSection = ({
  recognitions,
  onEditSectionClicked,
  isPublic = false,
  enableInViewAnimation,
}: IProps) => {
  const filteredRecognitions = recognitions?.filter((item) => {
    return Object.values(item).some((value) => {
      if (value === null || value === undefined) return false;
      if (typeof value === "string") return value.trim() !== "";
      return true;
    });
  });

  return (
    <ProfileSectionCard
      title="Notable Achievements"
      isEmpty={!filteredRecognitions || filteredRecognitions.length === 0}
      onEditSectionClicked={onEditSectionClicked}
      isPublic={isPublic}
      enableInViewAnimation={enableInViewAnimation}
    >
      <div className="mt-6 flex flex-col gap-6">
        {filteredRecognitions?.map((item, index) => (
          <Fragment key={index}>
            <ProfileSectionRow
              title={item.title}
              subTitle={
                item.date && (
                  <Typography
                    size="body-4"
                    as="span"
                    className="text-text-default-3"
                  >
                    {DateUtils.getLocalizedDate(item.date, "MMM d, yyyy")}
                  </Typography>
                )
              }
              index={index}
              sectionId="recongnitions"
              hasAdditionalInfo={!!item.description || !!item.category || !!item.issuer}
            >
              <ProfileWorkExperienceItem
                value={item.issuer}
                segment="Issuer"
              />

              <ProfileWorkExperienceItem
                value={item.category}
                segment="Category"
              />
              <ProfileWorkExperienceItem
                value={item.description}
                segment="Description"
              />
            </ProfileSectionRow>
            {index !== filteredRecognitions.length - 1 && <ItemSectionDivider />}
          </Fragment>
        ))}
      </div>
    </ProfileSectionCard>
  );
};

export default ProfileRecognitionsSection;
